module.exports = __webpack_public_path__ + "img/carousel-6.51129c82.jpg";